import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const KhodroShakhsSalesPaths: IPaths = {
  BimehNameh: {
    Print: '/Khodro/ShakhsSales/Print',
    List: '/Khodro/ShakhsSales/List',
    Detail: '/Khodro/ShakhsSales/Detail',
    SodoorByPelak: '/Khodro/ShakhsSales/SodoorByPelak',
    Tamdid: '/Khodro/ShakhsSales/Tamdid',
    EstelamAndSodoor: '/Khodro/ShakhsSales/EstelamAndSodoor',
    SodoorByTavizPelak: '/Khodro/ShakhsSales/SodoorByTavizPelak',
    ElhaghiyehSaderehDetail: '/Khodro/ShakhsSales/ElhaghiyehSaderehDetail',
  },
};
